module.exports = __webpack_public_path__ + "static/media/8.1020ae15.jpg";